import React from "react";
import "./goBack.scss";

import { t } from "i18next";

const GoBack = ({ previousStep, color = "#fff" }) => {
  return (
    <div
      style={{ color: color }}
      className="back-to-previous"
      onClick={() => {
        previousStep();
      }}
    >
      {t("common.back_to_previous")}
    </div>
  );
};

export default GoBack;
